import { gql } from '@/store/helpers/axios.js'

export default {
    async GET_FACULTY_UNIVERSITY_TYPES ({ commit }) {
        const query = `query cRMUniFaculties (
          $order: [CRMUniFacultySortInput!]
          $where: CRMUniFacultyFilterInput
        ) {
          response: cRMUniFaculties (where: $where order: $order) {
            field_001
            onlinestatus
            departementFaculty
            cRMUniUniversity {
              field_001
              university
            }
          }
        }`

        const variables = {
          order: {
            laufnummer: 'ASC'
          },
          where: {
            onlinestatus: { eq: '1' }
          }
        }

        const { data } = await gql({ query, variables })

        if (!data.errors) {
          commit('SET_FACULTY_UNIVERSITY_TYPES', data.data.response)
        }

        return data
      },
      async GET_UNIVERSITY_TYPES ({ commit }) {
        const query = `query cRMUniUniversities (
          $order: [CRMUniUniversitySortInput!]
        ) {
          response: cRMUniUniversities (order: $order) {
            field_001
            university
          }
        }`

        const variables = {
          order: {
            sortierung: 'ASC'
          }
        }

        const { data } = await gql({ query, variables })

        if (!data.errors) {
          commit('SET_UNIVERSITY_TYPES', data.data.response)
        }

        return data
      },
      async GET_BRANCHE_TYPES ({ commit }) {
        const query = `query cRMBranchen (
          $order: [CRMBrancheSortInput!]
        ) {
          response: cRMBranchen ( order: $order) {
              field_001
              brancheEn
          }
        }`

        const variables = {
          order: {
            sortierung: 'DESC',
            brancheEn: 'ASC'
          }
        }

        const { data } = await gql({ query, variables })

        if (!data.errors) {
          commit('SET_BRANCHE_TYPES', data.data.response)
        }

        return data
      },
      async GET_STARTUPHASE_TYPES ({ commit }) {
        const query = `query cRMStartupphases (
          $order: [CRMStartupphaseSortInput!]
        ) {
          response: cRMStartupphases (order: $order) {
              field_001
              startupphase
          }
        }`

        const variables = {
          order: {
            sortierung: 'DESC',
            startupphase: 'ASC'
          }
        }

        const { data } = await gql({ query, variables })

        if (!data.errors) {
          commit('SET_STARTUPPHASE_TYPES', data.data.response)
        }

        return data
      },
      async GET_COUNTRY_TYPES ({ commit }) {
        const query = `query cRMCountries (
          $order: [CRMCountrySortInput!]
        ) {
          response: cRMCountries (order: $order) {
              field_001
              land
          }
        }`

        const variables = {
          order: {
            sortierung: 'ASC',
            land: 'ASC'
          }
        }

        const { data } = await gql({ query, variables })

        if (!data.errors) {
          commit('SET_COUNTRY_TYPES', data.data.response)
        }

        return data
      },
      async GET_CASEQUALITY_TYPES ({ commit }) {
        const query = `query sEMINARCasequalities (
          $order: [SEMINARCasequalitySortInput!]
        ) {
          response: sEMINARCasequalities (order: $order) {
            field_001
            casequality
          }
        }`

        const variables = {
          order: {
            laufnummer: 'ASC'
          }
        }

        const { data } = await gql({ query, variables })

        if (!data.errors) {
          commit('SET_CASEQUALITY_TYPES', data.data.response)
        }

        return data
      },
      async GET_AFFIRMATION_TYPES ({ commit }) {
        const query = `query eVENTSignupAffirmations (
          $order: [EVENTSignupAffirmationSortInput!]
          $where: EVENTSignupAffirmationFilterInput
        ) {
          response: eVENTSignupAffirmations (where: $where order: $order) {
            field_001
            affirmationEN
            onlinestatusID
          }
        }`

        const variables = {
          order: {
            sortierung: 'ASC'
          },
          where: {
            onlinestatusID: { eq: '1' }
          }
        }

        const { data } = await gql({ query, variables })

        if (!data.errors) {
          commit('SET_AFFIRMATION_TYPES', data.data.response)
        }

        return data
      },
      async GET_RECHTSFORM_TYPES ({ commit }) {
        const query = `query cRMRechtsforms {
          response: cRMRechtsforms {
            field_001
            rechtsform
          }
        }`

        const { data } = await gql({ query })

        if (!data.errors) {
          commit('SET_RECHTSFORM_TYPES', data.data.response)
        }

        return data
      },
      async GET_LANGUAGES_TYPES ({ commit }) {
        const query = `query cRMLanguages {
          response: cRMLanguages {
            field_001
            spracheEN
          }
        }`

        const { data } = await gql({ query })

        if (!data.errors) {
          commit('SET_LANGUAGES_TYPES', data.data.response)
        }

        return data
      },
      async GET_EDUCATION_TYPES ({ commit }) {
        const query = `query cRMEducations (
          $order: [CRMEducationSortInput!]
          $where: CRMEducationFilterInput
        ) {
          response: cRMEducations (where: $where order: $order) {
            field_001
            education
            onlinestatus
          }
        }`

        const variables = {
          order: {
            sortierung: 'ASC'
          },
          where: {
            onlinestatus: { eq: '1' }
          }
        }

        const { data } = await gql({ query, variables })

        if (!data.errors) {
          commit('SET_EDUCATION_TYPES', data.data.response)
        }

        return data
      },
      async GET_CANTON_TYPES ({ commit }) {
        const query = `query cRMKantons (
          $order: [CRMKantonSortInput!]
          $where: CRMKantonFilterInput
        ) {
          response: cRMKantons (where: $where order: $order) {
            field_001
            kantonEN
            onlinestatus_id
          }
        }`

        const variables = {
          order: {
            krzel: 'ASC'
          },
          where: {
            onlinestatus_id: { eq: '1' }
          }
        }

        const { data } = await gql({ query, variables })

        if (!data.errors) {
          commit('SET_CANTON_TYPES', data.data.response)
        }

        return data
      },
      async GET_VKCASESTATUS_TYPES ({ commit }) {
        const query = `query vEKMISCaseStatuses (
          $order: [VEKMISCaseStatusSortInput!]
        ) {
          response: vEKMISCaseStatuses (order: $order) {
            field_001
            casestatus
          }
        }`

        const variables = {
          order: {
            sortierung: 'ASC'
          }
        }

        const { data } = await gql({ query, variables })

        if (!data.errors) {
          commit('SET_VKCASESTATUS_TYPES', data.data.response)
        }

        return data
      },
      async GET_SALUTATION_TYPES ({ commit }) {
        const query = `query cRMAnsprechzeilens (
          $order: [CRMAnsprechzeileSortInput!]
          $where: CRMAnsprechzeileFilterInput
        ) {
          response: cRMAnsprechzeilens (where: $where order: $order) {
            field_001
            ansprechzeile
            ansprechzeile_id
            geschlecht_PopupExtension
            onlinestatus_id
            sprache_idId
            iSGender
          }
        }`

        const variables = {
          order: {
            sortierung: 'ASC'
          },
          where: {
            sprache_idId: { eq: 4 }
          }
        }

        const { data } = await gql({ query, variables })

        if (!data.errors) {
          commit('SET_SALUTATION_TYPES', data.data.response)
        }

        return data
      },
      async GET_PRIOVLAB_TYPES ({ commit }) {
        const query = `query cRMPrioStatuses (
          $order: [CRMPrioStatusSortInput!]
          $where: CRMPrioStatusFilterInput
        ) {
          response: cRMPrioStatuses (where: $where order: $order) {
            field_001
            status
            onlinestatus
          }
        }`

        const variables = {
          order: {
            sortierung: 'ASC'
          },
          where: {
            onlinestatus: { eq: '1' }
          }
        }

        const { data } = await gql({ query, variables })

        if (!data.errors) {
          commit('SET_PRIOVLAB_TYPES', data.data.response)
        }

        return data
      },
      async GET_PRIOVLABXMAS_TYPES ({ commit }) {
        const query = `query cRMPrioStatusesXMas (
          $order: [CRMPrioStatusXMasSortInput!]
          $where: CRMPrioStatusXMasFilterInput
        ) {
          response: cRMPrioStatusesXMas (where: $where order: $order) {
            field_001
            statusxmas
            onlinestatus
          }
        }`

        const variables = {
          order: {
            sortierung: 'ASC'
          },
          where: {
            onlinestatus: { eq: '1' }
          }
        }

        const { data } = await gql({ query, variables })

        if (!data.errors) {
          commit('SET_PRIOVLABXMAS_TYPES', data.data.response)
        }

        return data
      },
      async GET_PROFILCATEGORY_TYPES ({ commit }) {
        const query = `query pROFILCategories (
          $order: [PROFILCategorySortInput!]
          $where: PROFILCategoryFilterInput
        ) {
          response: pROFILCategories (where: $where order: $order) {
            field_001
            kategorieDE
            onlinestatus_id
          }
        }`

        const variables = {
          order: {
            sortierung: 'ASC'
          },
          where: {
            onlinestatus_id: { eq: '1' }
          }
        }

        const { data } = await gql({ query, variables })

        if (!data.errors) {
          commit('SET_PROFILCATEGORY_TYPES', data.data.response)
        }

        return data
      },
      async GET_INVESTMENT_TYPES ({ commit }) {
        const query = `query cRMFundingInvestmentsTypeProfileV2s (
          $order: [CRMFundingInvestmentsTypeProfileV2SortInput!]
          $where: CRMFundingInvestmentsTypeProfileV2FilterInput
        ) {
          response: cRMFundingInvestmentsTypeProfileV2s (where: $where order: $order) {
            field_001
            investmentsType
            onlinestate
          }
        }`

        const variables = {
          order: {
            sort: 'ASC'
          },
          where: {
            onlinestate: { eq: '1' }
          }
        }

        const { data } = await gql({ query, variables })

        if (!data.errors) {
          commit('SET_INVESTMENT_TYPES', data.data.response)
        }

        return data
      },
      async GET_INVESTMENT_STAGES ({ commit }) {
        const query = `query cRMFundingInvestmentsStageProfileV2s (
          $order: [CRMFundingInvestmentsStageProfileV2SortInput!]
          $where: CRMFundingInvestmentsStageProfileV2FilterInput
        ) {
          response: cRMFundingInvestmentsStageProfileV2s (where: $where order: $order) {
            field_001
            investmentsStage
            onlinestate
          }
        }`

        const variables = {
          order: {
            sort: 'ASC'
          },
          where: {
            onlinestate: { eq: '1' }
          }
        }

        const { data } = await gql({ query, variables })

        if (!data.errors) {
          commit('SET_INVESTMENT_STAGES', data.data.response)
        }

        return data
      },
      async GET_PROFILE_STATUS ({ commit }) {
        const query = `query cRMFundingStatusProfileV2s (
          $order: [CRMFundingStatusProfileV2SortInput!]
          $where: CRMFundingStatusProfileV2FilterInput
        ) {
          response: cRMFundingStatusProfileV2s (where: $where order: $order) {
            field_001
            status
            onlinestate
          }
        }`

        const variables = {
          order: {
            sort: 'ASC'
          },
          where: {
            onlinestate: { eq: '1' }
          }
        }

        const { data } = await gql({ query, variables })

        if (!data.errors) {
          commit('SET_PROFILE_STATUS', data.data.response)
        }

        return data
      },
      async GET_TYPE_OF_ORGANIZATION ({ commit }) {
        const query = `query cRMAdresseTypeofOrganisations (
          $order: [CRMAdresseTypeofOrganisationSortInput!]
          $where: CRMAdresseTypeofOrganisationFilterInput
        ) {
          response: cRMAdresseTypeofOrganisations (where: $where order: $order) {
            field_001
            typeofOrganization
          }
        }`

        const variables = {
          order: {
            sortierung: 'ASC'
          }
        }

        const { data } = await gql({ query, variables })

        if (!data.errors) {
          commit('SET_TYPE_OF_ORGANIZATION', data.data.response)
        }

        return data
      },
      async GET_ROLES ({ commit }) {
        const query = `query cRMRolles (
          $order: [CRMRolleSortInput!]
          $where: CRMRolleFilterInput
        ) {
          response: cRMRolles (where: $where order: $order) {
            field_001
            rolle
            onlinestatus_id
            sortierung
          }
        }`

        const variables = {
          order: {
            sortierung: 'ASC'
          },
          where: {
            onlinestatus_id: { eq: '1' }
          }
        }

        const { data } = await gql({ query, variables })

        if (!data.errors) {
          commit('SET_ROLES', data.data.response)
        }

        return data
      },
      async GET_VEKMIS_TECHNOLOGY ({ commit }) {
        const query = `query vEKMISTechnologies (
          $order: [VEKMISTechnologySortInput!]
          $where: VEKMISTechnologyFilterInput
        ) {
          response: vEKMISTechnologies (where: $where order: $order) {
            field_001
            technologyEN
            onlinestatus
            sortierung
          }
        }`

        const variables = {
          order: {
            sortierung: 'ASC'
          },
          where: {
            onlinestatus: { eq: '1' }
          }
        }

        const { data } = await gql({ query, variables })

        if (!data.errors) {
          commit('SET_VEKMIS_TECHNOLOGY', data.data.response)
        }

        return data
      },
      async GET_INTERESTS ({ commit }) {
        const query = `query gRUNDWERTEInteresses (
          $order: [GRUNDWERTEInteressSortInput!]
          $where: GRUNDWERTEInteressFilterInput
        ) {
          response: gRUNDWERTEInteresses (where: $where order: $order) {
            field_001
            interesse_en
            onlinestatus
          }
        }`

        const variables = {
          order: {
            interesse_en: 'ASC'
          },
          where: {
            onlinestatus: { eq: '1' }
          }
        }

        const { data } = await gql({ query, variables })

        if (!data.errors) {
          commit('SET_INTERESTS', data.data.response)
        }

        return data
      },
      async GET_AWARDS ({ commit }) {
        const query = `query cONTESTExecutions (
          $order: [CONTESTExecutionSortInput!]
        ) {
          response: cONTESTExecutions (where: {cONTESTContest: [{ category_idId: { eq: 1 } }, { onlinestatus_id: { eq: "1"} }]}, order: $order) {
            field_001
            contest_release
            date
            cONTESTContest {
              field_001
              category_idId
              onlinestatus_id
            }
          }
        }`

        const variables = {
          order: {
            date: 'ASC'
          }
        }

        const { data } = await gql({ query, variables })

        if (!data.errors) {
          commit('SET_AWARDS', data.data.response)
        }

        return data
      },
      async GET_SECTORS ({ commit }) {
        const query = `query pROFILCategories (
          $order: [PROFILCategorySortInput!]
          $where: PROFILCategoryFilterInput
        ) {
          response: pROFILCategories (where: $where order: $order) {
            field_001
            kategorieDE
            hauptkategorie_idId
            onlinestatus_id
            sortierung
            pROFILHauptcategory {
              field_001
              hauptkategorieDE
            }
          }
        }`

        const variables = {
          order: {
            sortierung: 'ASC'
          },
          where: {
            onlinestatus_id: { eq: '1' }
          }
        }

        const { data } = await gql({ query, variables })

        if (!data.errors) {
          commit('SET_SECTORS', data.data.response)
        }

        return data
      },
      async GET_REPORTING_GROUPS ({ commit }) {
        const query = `query pROFILReportingGroups (
          $order: [PROFILReportingGroupSortInput!]
          $where: PROFILReportingGroupFilterInput
        ) {
          response: pROFILReportingGroups (where: $where order: $order) {
            field_001
            reportingGroups
            onlinestate
            sort
          }
        }`

        const variables = {
          order: {
            sort: 'ASC'
          },
          where: {
            onlinestate: { eq: '1' }
          }
        }

        const { data } = await gql({ query, variables })

        if (!data.errors) {
          commit('SET_REPORTING_GROUPS', data.data.response)
        }

        return data
      },
      async GET_EVENT_SIGNUP_FUNKTION ({ commit }) {
        const query = `query eVENTSignupFunktions (
          $order: [EVENTSignupFunktionSortInput!]
        ) {
          response: eVENTSignupFunktions (order: $order) {
            field_001
            funktionEN
          }
        }`

        const variables = {
          order: {
            sortierung: 'ASC'
          },
          where: {
            onlinestatusID: { eq: '1' }
          }
        }

        const { data } = await gql({ query, variables })

        if (!data.errors) {
          commit('SET_EVENT_SIGNUP_FUNKTION', data.data.response)
        }

        return data
      },
      async GET_EVENT_STARTUP_STAGE_IS_2025 ({ commit }) {
        const query = `query eVENTEventStartupStageInnosuisse2025s (
          $order: [EVENTEventStartupStageInnosuisse2025SortInput!]
          $where: EVENTEventStartupStageInnosuisse2025FilterInput
        ) {
          response: eVENTEventStartupStageInnosuisse2025s (where: $where order: $order) {
            field_001
            startupstage
          }
        }`

        const variables = {
          order: {
            sort: 'ASC'
          },
          where: {
            onlinestate: { eq: '1' }
          }
        }

        const { data } = await gql({ query, variables })

        if (!data.errors) {
          commit('SET_EVENT_STARTUP_STAGE_IS_2025', data.data.response)
        }

        return data
      },
      async GET_EVENT_STARTUP_SECTORS_IS_2025 ({ commit }) {
        const query = `query eVENTEventStartupSectorsInnosuisse2025s (
          $order: [EVENTEventStartupSectorsInnosuisse2025SortInput!]
          $where: EVENTEventStartupSectorsInnosuisse2025FilterInput
        ) {
          response: eVENTEventStartupSectorsInnosuisse2025s (where: $where order: $order) {
            field_001
            sector
          }
        }`

        const variables = {
          order: {
            sort: 'ASC'
          },
          where: {
            onlinestate: { eq: '1' }
          }
        }

        const { data } = await gql({ query, variables })

        if (!data.errors) {
          commit('SET_EVENT_STARTUP_SECTORS_IS_2025', data.data.response)
        }

        return data
      },
      async GET_EVENT_INDUSTRY_EXPERIENCE_IS_2025 ({ commit }) {
        const query = `query eVENTEventIndustryExperienceInnosuisse2025s (
          $order: [EVENTEventIndustryExperienceInnosuisse2025SortInput!]
          $where: EVENTEventIndustryExperienceInnosuisse2025FilterInput
        ) {
          response: eVENTEventIndustryExperienceInnosuisse2025s (where: $where order: $order) {
            field_001
            yearsofindustryexperience
          }
        }`

        const variables = {
          order: {
            sort: 'ASC'
          },
          where: {
            onlinestate: { eq: '1' }
          }
        }

        const { data } = await gql({ query, variables })

        if (!data.errors) {
          commit('SET_EVENT_INDUSTRY_EXPERIENCE_IS_2025', data.data.response)
        }

        return data
      },
      async GET_EVENT_STARTUP_RELATIONSHIP_UNI_IS_2025 ({ commit }) {
        const query = `query eVENTEventStartuprelationshipUniIS2025s (
          $order: [EVENTEventStartuprelationshipUniIS2025SortInput!]
          $where: EVENTEventStartuprelationshipUniIS2025FilterInput
        ) {
          response: eVENTEventStartuprelationshipUniIS2025s (where: $where order: $order) {
            field_001
            currentrelationshipwiththeUniversity
          }
        }`

        const variables = {
          order: {
            sort: 'ASC'
          },
          where: {
            onlinestate: { eq: '1' }
          }
        }

        const { data } = await gql({ query, variables })

        if (!data.errors) {
          commit('SET_STARTUP_RELATIONSHIP_UNI_IS_2025', data.data.response)
        }

        return data
      },
      async GET_EVENT_EMPLOYMENTSTATUS_IS_2025 ({ commit }) {
        const query = `query eVENTEventEmploymentstatusInnosuisse2025s (
          $order: [EVENTEventEmploymentstatusInnosuisse2025SortInput!]
          $where: EVENTEventEmploymentstatusInnosuisse2025FilterInput
        ) {
          response: eVENTEventEmploymentstatusInnosuisse2025s (where: $where order: $order) {
            field_001
            employmentstatus
          }
        }`

        const variables = {
          order: {
            sort: 'ASC'
          },
          where: {
            onlinestate: { eq: '1' }
          }
        }

        const { data } = await gql({ query, variables })

        if (!data.errors) {
          commit('SET_EVENT_EMPLOYMENTSTATUS_IS_2025', data.data.response)
        }

        return data
      }
}
